import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Input, InputNumber, Select, Form, Divider, DatePicker, Button, Alert } from 'antd';
import { useIdType, useGetCountriesNew, useRelationshiplist } from 'all-in-one-shared-api';
import { useEffect, useState, Dispatch } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { isLocaleEnglish } from 'utils/languageUtils';
import { beneficiariesForm } from 'contexts/beneficiaries/beneficiariesForm';
import styled from 'styled-components';
import './Changepastyle.less';
// import TooltipIcon from 'assets/images/policy/Tooltip.svg';
import moment from 'moment';

import { disabledDate } from 'utils';
import dateIcon from 'assets/images/MakeRequest/date.svg';
import { useBeneficiaries, initialState } from 'contexts/beneficiaries/context';
import { BeneficiariesActionTypes } from 'contexts/beneficiaries/action';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { isValidHongKongNonPermanentID, validateHKID, isValidChinaID } from '../../../utils';
import { formatIdlast5 } from 'utils/formate/cardNumber';
import Visibility from 'assets/images/eye-open.svg';
import VisibilityOff from 'assets/images/eye-off.svg';
// import { beneficiaryInfoItem } from 'all-in-one-shared-api/dist/apis/benefits/useLifeBeneficiaryInfo';
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  background: #fff;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  // background: #fff;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 16px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
interface LocationState {
  type: string;
  editCodeFlag: string;
  beneficiary?: beneficiariesForm;
  setEditOrAddShow: Dispatch<React.SetStateAction<boolean>>;
  setFirstFlag: Dispatch<React.SetStateAction<boolean>>;
}
interface countrylist {
  label: string;
  value: string;
  descEn: string;
  descTc: string;
  riskLevel: string;
  code: string;
  isSanction: boolean;
}

export const ChangeBeneficiariesCard = ({
  type,
  editCodeFlag,
  beneficiary,
  setEditOrAddShow,
  setFirstFlag,
}: LocationState) => {
  const { t, i18n } = useTranslation();
  const { state, dispatch, policyNC, companyCodeNc, setHighRiskC, highRiskC, oldBeneficiariesList } =
    useBeneficiaries();
  const [form] = Form.useForm();
  const { useWatch } = Form;
  const { token } = useKeycloakReady();
  const [updateState, setUpdateState] = useState(false);
  const [errorMes, setErrorMes] = useState('');
  const [idTypeList, setIdTypeList] = useState<{ label: string; value: string; labeltc: string; labelen: string }[]>(
    [],
  );
  const [idValue, setIdValue] = useState<string>('');
  const allObj: (keyof beneficiariesForm)[] = [
    'surname',
    'givenName',
    'share',
    'relationship',
    'gender',
    'birthDate',
    'idType',
    'idNo',
    'birthCountry',
    'residenceCountry',
    'taxResidence',
    'specifyRelationship',
  ]; //配置所有需要属性
  const [myCountryList, setMyCountryList] = useState<countrylist[]>([]);
  // const { type, editCodeFlag, beneficiary } = useMemo(() => (location.state as LocationState) ?? {}, [location.state]);
  const [RsList, setRsList] = useState<
    {
      label: string;
      value: string;
      labeltc: string;
      labelen: string;
    }[]
  >([]);
  const [GList] = useState<
    {
      label: string;
      value: string;
      desc: string;
      descTc: string;
    }[]
  >([
    {
      label: t('life.beneficiaries.man'),
      value: 'M',
      desc: 'Male',
      descTc: '男',
    },
    {
      label: t('life.beneficiaries.woman'),
      value: 'F',
      desc: 'Female',
      descTc: '女',
    },
  ]);

  const isEnglish = isLocaleEnglish(i18n.language);
  const [residenceHigh, setResidenceHigh] = useState(false);
  const [birthHigh, setBirthHigh] = useState(false);
  const [highRiskFlag, setHighRiskFlag] = useState(false);
  const [birthSan, setBirthSan] = useState(false);
  const [residenceSan, setResidenceSan] = useState(false);
  const [sanctionFlag, setSanctionFlag] = useState(false);
  const [showIdCard, setShowIdCard] = useState<boolean>(true);
  const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token ?? '');
  const { data: relationList, shouldFetch: shouldFetchRelation } = useRelationshiplist(
    'useRelationshiplist',
    token ?? '',
    companyCodeNc,
  );
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token ?? '',
    policyNC ?? '',
    companyCodeNc ?? '',
  );

  const rsChange = (e: string) => {
    const desc = RsList.filter((item) => item.value == e);
    form.setFieldsValue({ relationshipDesc: desc[0].labelen, relationshipDescTc: desc[0].labeltc });
  };
  const gChange = (e: string) => {
    form.setFieldsValue({
      genderDesc: GList.find((item) => item.value == e)?.desc,
      genderDescTc: GList.find((item) => item.value == e)?.descTc,
    });
  };
  const idTypeChange = (e: string) => {
    form.setFieldsValue({
      idTypeDesc: idTypeList.find((item) => item.value == e)?.labelen,
      idTypeDescTc: idTypeList.find((item) => item.value == e)?.labeltc,
    });
  };

  const onSubmit = (values: beneficiariesForm) => {
    const onePerson = state.some(
      (item) => item.beneficiaryAction != 'removed' && item.idNo == idValue && item.idType == values.idType,
    );
    if (onePerson && editCodeFlag == 'add') {
      setErrorMes(t('life.beneficiaries.onePerson'));
      return;
    } else setErrorMes('');
    if (sanctionFlag || birthSan || residenceSan) {
      setErrorMes(t('life.beneficiaries.sanction'));
      return;
    } else setErrorMes('');

    form.setFieldsValue({
      ...values,
      share: values.share.toString(),
      // taxResidenceDesc: tax.map((item) => item.descEn).join(';'),
      // taxResidenceDescTc: tax.map((item) => item.descTc).join(';'),
      birthCountryDesc: myCountryList.find((item) => values.birthCountry == item.code)?.descEn,
      birthCountryDescTc: myCountryList.find((item) => values.birthCountry == item.code)?.descTc,
      residenceCountryDesc: myCountryList.find((item) => values.residenceCountry == item.code)?.descEn,
      residenceCountryDescTc: myCountryList.find((item) => values.residenceCountry == item.code)?.descTc,
    });
    const allValues = form.getFieldsValue(true);
    const oldData = oldBeneficiariesList.find((item) => item.id == allValues.id);
    values.idNo = idValue;
    if (oldData) {
      let flag = true;
      allObj.map((key) => {
        if (
          (key == 'taxResidence' &&
            JSON.stringify([...(oldData[key] || [])].sort()) != JSON.stringify([...(values[key] || [])].sort())) ||
          (key == 'share' && Number(oldData[key]) != Number(values[key])) ||
          (key != 'share' && key != 'taxResidence' && oldData[key] != values[key])
        ) {
          flag = false;
          return;
        }
      });
      if (flag) {
        setErrorMes(t('life.MakeRequest.hasnochange'));
        return;
      }
    }
    if (editCodeFlag == 'add') {
      dispatch({
        type: BeneficiariesActionTypes.ADD,
        payload: {
          ...allValues,
          id: Math.random()
            .toString(36)
            .substring(2, 2 + 8),
          idNo: idValue,
        },
      });
    } else {
      dispatch({
        type: BeneficiariesActionTypes.UPDATEITEM,
        payload: {
          ...allValues,
          beneficiaryAction: 'updated',
          idNo: idValue,
        },
      });
    }
    setUpdateState(true);
  };
  useEffect(() => {
    if (updateState) {
      setEditOrAddShow(false);
      setFirstFlag(false);
    }

    // navigate('/LIBenefiaries', {
    //   state: {
    //     transit: true,
    //     editflag: true,
    //   },
    // });
  }, [updateState, setEditOrAddShow, setFirstFlag]);
  useEffect(() => {
    shouldFetchIdType(true);
    shouldFecthGetCountry(true);
    shouldFetchRelation(true);
    // return () => {
    //   form.resetFields(); // 在组件卸载时清空表单
    // };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (editCodeFlag == 'updated' && beneficiary && myCountryList.length > 0 && RsList.length > 0) {
      const birthCountry = myCountryList.find((item) => item.value === beneficiary.birthCountry);
      const residenceCountry = myCountryList.find((item) => item.value === beneficiary.residenceCountry);
      const taxResidence = myCountryList.filter((item) => beneficiary.taxResidence?.includes(item.value));
      setIdValue(beneficiary.idNo ?? '');
      setBirthSan(birthCountry?.isSanction || false);
      setResidenceSan(residenceCountry?.isSanction || false);
      setSanctionFlag(taxResidence.some((item) => item.isSanction));
      setBirthHigh(birthCountry?.riskLevel.toLowerCase() == 'HIGH'.toLowerCase());
      setResidenceHigh(residenceCountry?.riskLevel.toLowerCase() == 'HIGH'.toLowerCase());
      setHighRiskFlag(taxResidence.some((item) => item.riskLevel.toLowerCase() == 'HIGH'.toLowerCase()));
      const rs = RsList.some((item) => item.value == beneficiary.relationship);
      form.setFieldsValue({
        ...beneficiary,
        idNo: showIdCard ? formatIdlast5(beneficiary.idNo ?? '') : beneficiary.idNo,
        relationship: rs ? beneficiary.relationship : 'O',
        relationshipDesc: rs
          ? beneficiary.relationshipDesc
          : RsList.find((item) => item.value === 'O')?.labelen || 'Other',
        relationshipDescTc: rs
          ? beneficiary.relationshipDescTc
          : RsList.find((item) => item.value === 'O')?.labeltc || '其他',
        gender: beneficiary.gender ? beneficiary.gender : null,
        idType: beneficiary.idType ? beneficiary.idType : null,
        birthCountry: birthCountry?.value ? birthCountry?.value : null,
        residenceCountry: residenceCountry?.value ? residenceCountry?.value : null,
        taxResidence: taxResidence.map((item) => item.value),
        taxResidenceDesc: taxResidence?.map((item) => item.descEn).join(';'),
        taxResidenceDescTc: taxResidence?.map((item) => item.descTc).join(';'),
        birthCountryDesc: birthCountry?.descEn,
        birthCountryDescTc: birthCountry?.descTc,
        residenceCountryDesc: residenceCountry?.descEn,
        residenceCountryDescTc: residenceCountry?.descTc,
        share: beneficiary.share?.replace(/%/g, '')
          ? beneficiary.share != '0'
            ? (beneficiary.share.indexOf('.') != -1 && beneficiary.share[beneficiary.share.indexOf('.') + 1] == '0') ||
              beneficiary.share.indexOf('.') == -1
              ? Number(beneficiary.share)
              : undefined
            : undefined
          : undefined,
        // 确保 id 存在时才设置
        ...(beneficiary.id && { id: beneficiary.id }),
      });
    }
    if (editCodeFlag == 'add')
      form.setFieldsValue({
        ...initialState,
        beneficiaryAction: editCodeFlag,
        role: type == 'secondary' ? 'G' : '',
      });
    // eslint-disable-next-line
  }, [editCodeFlag, beneficiary, myCountryList, RsList]);

  useEffect(() => {
    const idTypeList: { label: string; value: string; labeltc: string; labelen: string }[] = [];
    if (idType && idType.length > 0) {
      // shouldFetchIdType(false);
      idType?.map((item: { idTypeDesc: string; idTypeDescTc: string; idType: string }) => {
        idTypeList.push({
          label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
          value: item.idType,
          labeltc: item.idTypeDescTc,
          labelen: item.idTypeDesc,
        });
      });
      setIdTypeList(idTypeList);
    }
    if (relationList && relationList.length > 0) {
      const relation: { label: string; value: string; labeltc: string; labelen: string }[] = [];
      relationList?.map((item: { relationshipCode: string; relationshipDesc: string; relationshipDescTc: string }) => {
        relation.push({
          label: `${isEnglish ? item.relationshipDesc : item.relationshipDescTc}`,
          labeltc: item.relationshipDescTc,
          labelen: item.relationshipDesc,
          value: item.relationshipCode,
        });
      });
      setRsList(relation);
    }
    if (countriesDataList && countriesDataList?.residentialCountries) {
      shouldFecthGetCountry(false);
      setMyCountryList(
        countriesDataList?.residentialCountries.map((item) => {
          return {
            label: isEnglish ? item.countryName : item.countryNameTc,
            value: item.t3645Alpha3Country,
            riskLevel: item.riskLevel,
            code: item.t3645Alpha3Country,
            descEn: item.countryName,
            descTc: item.countryNameTc,
            isSanction: item.isSanction,
          };
        }),
      );
    }
  }, [idType, countriesDataList, relationList, isEnglish, shouldFecthGetCountry, shouldFetchIdType]);

  const DividerLine = ({ padB }: DividerLineProps) => {
    return (
      <Androw justify="start" padB={padB}>
        <AndCol style={{ width: '100%' }}>
          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
        </AndCol>
      </Androw>
    );
  };
  const multiplyTax = (e: Array<string>) => {
    const tax = myCountryList.filter((item) => e.includes(item.code));
    form.setFieldsValue({
      taxResidenceDesc: tax.map((item) => item.descEn).join(';'),
      taxResidenceDescTc: tax.map((item) => item.descTc).join(';'),
    });
    setHighRiskFlag(
      myCountryList
        ?.filter((item) => e.includes(item.code))
        .some((item) => item.riskLevel.toLowerCase() == 'HIGH'.toLowerCase()),
    );
    setSanctionFlag(myCountryList.filter((item) => e.includes(item.code)).some((item) => item.isSanction));
  };
  const highRisk = (value: string, type: string) => {
    if (type == 'birthCountry') {
      setBirthHigh(myCountryList?.find((item) => item.code === value)?.riskLevel.toLowerCase() == 'HIGH'.toLowerCase());
      setBirthSan(myCountryList.find((item) => item.code == value)?.isSanction || false);
    } else {
      setResidenceHigh(
        myCountryList?.find((item) => item.code === value)?.riskLevel.toLowerCase() == 'HIGH'.toLowerCase(),
      );
      setResidenceSan(myCountryList.find((item) => item.code == value)?.isSanction || false);
    }
  };
  const changeIdvalue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setIdValue(value);
    return value;
  };

  const IdCardBlur = () => {
    if (showIdCard && form.getFieldValue('idNo')) {
      form.setFieldsValue({
        idNo: formatIdlast5(idValue),
      });
    } else {
      form.setFieldsValue({
        idNo: idValue,
      });
    }
  };
  useEffect(() => {
    if (idValue) IdCardBlur();
    // eslint-disable-next-line
  }, [showIdCard]);
  const changeIdCard = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowIdCard(!showIdCard);
  };
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [isEnglish, form]);
  useEffect(() => {
    if (highRiskFlag || residenceHigh || birthHigh) setHighRiskC(true);
  }, [highRiskFlag, residenceHigh, birthHigh, highRiskC, setHighRiskC]);

  return (
    <StyledBlock>
      <Androw justify="start" paddingFlag="16px">
        <AndCol className="font-size26 grey-font">{t('life.policies.appointment')}</AndCol>
        <AntDivider style={{ margin: '12px 0 8px 0' }}></AntDivider>
      </Androw>
      <Androw justify="start">
        <AndCol>
          <div className="tagging">
            <span className="font-size17 font-setting500 grey-font">
              {type == 'primary' ? t('life.policies.Primarybeneficiaries') : t('life.policies.SecondaryTitle')}
            </span>
          </div>
        </AndCol>
      </Androw>
      <DividerLine></DividerLine>
      <Form
        layout={'vertical'}
        requiredMark={false}
        form={form}
        onFinish={onSubmit}
        validateTrigger={'onBlur'}
        className="form beneficiaries-form"
        preserve={false}
        scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
      >
        <Row className="form-row">
          <Row
            justify="center"
            gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
            style={{ rowGap: 0 }}
            className="ChangePaymentContactCard"
          >
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.surname')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.surname')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="surname"
              >
                <Input
                  size="middle"
                  placeholder={t('life.beneficiaries.surname')}
                  style={{
                    color: '#20252B',
                    // backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 10px',
                  }}
                />
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.givenName')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.givenName')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="givenName"
              >
                <Input
                  placeholder={t('life.beneficiaries.givenName')}
                  size="middle"
                  style={{
                    color: '#20252B',
                    // backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 10px',
                  }}
                />
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[
                  () => ({
                    validator(_, value) {
                      // 检查是否为 null、undefined 或空字符串
                      if (value === null || value === undefined || value === '') {
                        return Promise.reject(new Error(t('common.error.requiredField')));
                      }

                      const numValue = Number(value);
                      // 检查是否为有效数字且在 1-100 范围内
                      if (!isNaN(numValue) && numValue > 0 && numValue <= 100) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t('life.beneficiaries.shareError')));
                    },
                  }),
                ]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.share')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.share')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="share"
              >
                <div className="input-number-wrap">
                  <InputNumber
                    size="large"
                    className="input-number"
                    value={useWatch('share', form)}
                    onChange={(value) => {
                      form.setFieldsValue({ share: value });
                    }}
                    placeholder={t('life.beneficiaries.share')}
                    style={{
                      width: '100%',
                      fontSize: '20px',
                      color: '#20252B',
                      fontFamily: 'Roboto400',
                    }}
                    // max={100}
                    min={0}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-') {
                        // 禁止输入小数点和符号
                        e.preventDefault();
                      }
                    }}
                  />
                  <span className="input-number-suffix">%</span>
                </div>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.relationship')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.relationship')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="relationship"
              >
                <Select
                  onChange={rsChange}
                  size="large"
                  popupClassName="slectop"
                  placeholder={t('life.beneficiaries.relationship')}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                >
                  {RsList &&
                    RsList.map((item) => (
                      <Select.Option key={item.value} value={item.value} label={item.label}>
                        <span>{item.label}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => prevValues.relationship !== currentValues.relationship}
              >
                {({ getFieldValue }) =>
                  getFieldValue('relationship') === 'O' ? (
                    // <Col xs={24} md={24}>
                    <BoldLabelFormItem
                      rules={[{ required: true, message: t('common.error.requiredField') }]}
                      required
                      label=""
                      className="label-form-item no-label"
                      name="specifyRelationship"
                    >
                      <Input
                        size="middle"
                        placeholder={t('life.beneficiaries.specify')}
                        style={{
                          color: '#20252B',
                          // backgroundColor: 'transparent',
                          fontSize: '20px',
                          fontFamily: 'Roboto400',
                          padding: '4px 10px',
                        }}
                      />
                    </BoldLabelFormItem>
                  ) : // </Col>
                  null
                }
              </Form.Item>
            </Col>

            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.gender')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.gender')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="gender"
              >
                <Select
                  onChange={gChange}
                  size="large"
                  placeholder={t('life.beneficiaries.gender')}
                  popupClassName="slectop"
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                >
                  {GList &&
                    GList.map((item) => (
                      <Select.Option key={item.value} value={item.value} label={item.label}>
                        <span>{isEnglish ? item.desc : item.descTc}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.birthDate')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.birthDate')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="birthDate"
                normalize={(value) => {
                  // 提交表单时，将 moment 对象转为 'DD/MM/YYYY' 字符串
                  return value?.format('DD/MM/YYYY');
                }}
                getValueProps={(value) => {
                  // 从表单数据初始化时，将字符串转为 moment 对象
                  return { value: value ? moment(value, 'DD/MM/YYYY') : null };
                }}
              >
                <DatePicker
                  className="customDatePicker"
                  disabledDate={disabledDate}
                  suffixIcon={<img src={dateIcon}></img>}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  // value={birthDate ? moment(birthDate, 'YYYY-MM-DD') : null}
                  style={{
                    color: '#20252B',
                    backgroundColor: 'transparent',
                    width: '100%',
                    fontSize: '20px',
                  }}
                />
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.idType')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.idType')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="idType"
              >
                <Select
                  onChange={idTypeChange}
                  size="large"
                  popupClassName="slectop"
                  placeholder={t('life.beneficiaries.idType')}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                >
                  {idTypeList &&
                    idTypeList.map((item) => (
                      <Select.Option key={item.value} value={item.value} label={item.label}>
                        <span>{item.label}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[
                  // { required: true, message: t('common.error.requiredField') },
                  {
                    validator(_, value) {
                      let flag = false;
                      if (!value) return Promise.reject(new Error(t('common.error.requiredField')));
                      if (value && form.getFieldValue('idType')) {
                        if (form.getFieldValue('idType') == 'HKID') {
                          flag = validateHKID(idValue);
                        } else if (form.getFieldValue('idType') == 'HKNID') {
                          flag = isValidHongKongNonPermanentID(idValue);
                        } else if (form.getFieldValue('idType') == 'ChinaID') {
                          flag = isValidChinaID(idValue);
                        } else {
                          flag = true;
                        }
                        if (flag) {
                          return Promise.resolve();
                        } else return Promise.reject(new Error(t('life.MakeRequest.payment.IdNumber')));
                      }
                    },
                  },
                ]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.idNo')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.idNo')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="idNo"
              >
                <Input
                  size="middle"
                  onChange={changeIdvalue}
                  placeholder={t('life.beneficiaries.idNo')}
                  style={{
                    color: '#20252B',
                    // backgroundColor: 'transparent',
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 10px',
                  }}
                  onBlur={IdCardBlur}
                  onFocus={() => form.setFieldValue('idNo', idValue)}
                  suffix={
                    showIdCard ? (
                      <img src={Visibility} onClick={(e) => changeIdCard(e)} />
                    ) : (
                      <img src={VisibilityOff} onClick={(e) => changeIdCard(e)} />
                    )
                  }
                />
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.birthCountry')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.birthCountry')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="birthCountry"
              >
                <Select
                  showSearch
                  onChange={(value) => highRisk(value, 'birthCountry')}
                  size="large"
                  popupClassName="slectop"
                  placeholder={t('life.beneficiaries.birthCountry')}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                  filterOption={(input, option) => {
                    const label = option?.label ?? '';
                    return typeof label === 'string' ? label.toLowerCase().includes(input.toLowerCase()) : false;
                  }}
                >
                  {myCountryList &&
                    myCountryList.map((item) => (
                      <Select.Option key={item.value} value={item.value} label={item.label}>
                        <span>{isEnglish ? item.descEn : item.descTc}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.residenceCountry')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.residenceCountry')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item"
                name="residenceCountry"
              >
                <Select
                  showSearch
                  onChange={(value) => highRisk(value, 'residenceCountry')}
                  size="large"
                  popupClassName="slectop"
                  placeholder={t('life.beneficiaries.residenceCountry')}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                  filterOption={(input, option) => {
                    const label = option?.label ?? '';
                    return typeof label === 'string' ? label.toLowerCase().includes(input.toLowerCase()) : false;
                  }}
                >
                  {myCountryList &&
                    myCountryList.map((item) => (
                      <Select.Option key={item.value} value={item.value} label={item.label}>
                        <span>{isEnglish ? item.descEn : item.descTc}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24} className="col-b">
              <BoldLabelFormItem
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div className="form-label">
                    <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                      {t('life.beneficiaries.taxResidenceLabel')}
                    </span>
                    {/* <Tooltip
                      trigger="click"
                      title={t('life.beneficiaries.taxResidence')}
                      arrowPointAtCenter
                      autoAdjustOverflow
                      placement="bottomRight"
                    >
                      <img src={TooltipIcon} alt="" style={{ cursor: 'pointer' }} width={20} height={20} />
                    </Tooltip> */}
                  </div>
                }
                className="label-form-item tax-residence"
                name="taxResidence"
              >
                <Select
                  onChange={multiplyTax}
                  mode="multiple"
                  size="large"
                  popupClassName="slectop"
                  placeholder={t('life.beneficiaries.taxResidenceLabel')}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    padding: '4px 0',
                    color: '#20252B',
                  }}
                  filterOption={(input, option) => {
                    let label = '';
                    if (isEnglish) {
                      label = option?.descEn;
                      return typeof label === 'string' ? label.toLowerCase().includes(input.toLowerCase()) : false;
                    } else {
                      label = option?.descTc;
                      return typeof label === 'string' ? label.toLowerCase().includes(input.toLowerCase()) : false;
                    }
                  }}
                >
                  {myCountryList &&
                    myCountryList.map((item) => (
                      <Select.Option
                        key={item.value}
                        value={item.value}
                        label={item.label}
                        descEn={item.descEn}
                        descTc={item.descTc}
                      >
                        <span>{isEnglish ? item.descEn : item.descTc}</span>
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
          </Row>
        </Row>
        <Androw justify="center" style={{ marginTop: '20px' }}>
          {errorMes && (
            <AndCol>
              <Alert
                message={errorMes}
                type="error"
                // closable
                className="error-forgot"
                style={{ marginBottom: 0 }}
              />
            </AndCol>
          )}
        </Androw>
        <Androw justify="start">
          <Col style={{ width: '100%' }}>
            <div className="confrimbutton">
              <Button
                // loading={enquirySubmissionIsLoading || isLoading}
                onClick={() => form.submit()}
                type="primary"
                className="subbutton"
                style={{ cursor: 'pointer' }}
                htmlType="button"
              >
                {t('life.beneficiaries.save')}
              </Button>
              <Button
                // loading={enquirySubmissionIsLoading || isLoading}
                onClick={() => setEditOrAddShow(false)}
                className="cancel"
                style={{ cursor: 'pointer' }}
              >
                {t('life.beneficiaries.cancel')}
              </Button>
            </div>
          </Col>
        </Androw>
      </Form>
    </StyledBlock>
  );
};
